import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import useComponentBounds from '../../../../../../hooks/useComponentBounds';
import {
  getCardElementFrameContainerStyle,
  getCardElementFrameStyle,
} from '../CardDesignerCardElementFrame/helpers';

const propTypes = {
  className: PropTypes.string,
  element: PropTypes.shape({
    cardElement: PropTypes.object.isRequired,
    cardElementConfiguration: PropTypes.object.isRequired,
  }).isRequired,
};

const CardDesignerCardElementForeground = ({ className, element }) => {
  const ref = useRef();
  const { bounds } = useComponentBounds(ref);
  const classes = classNames({
    [className]: !!className,
    'card-designer-card-element-foreground': true,
  });

  return (
    <div
      ref={ref}
      className={classes}
      style={{
        position: 'absolute',
        ...getCardElementFrameStyle(element),
      }}
    >
      <div style={{ ...getCardElementFrameContainerStyle(element, bounds) }} />
    </div>
  );
};

CardDesignerCardElementForeground.propTypes = propTypes;

export default CardDesignerCardElementForeground;
